var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmployeesOrange(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.385,
    height: 12.672,
    viewBox: "0 0 19.385 12.672",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12185",
    "data-name": "Group 12185",
    transform: "translate(-75.476 -329.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44591",
    "data-name": "Path 44591",
    d: "M66.342,72.8H62.623c-.481,0-.646-.163-.646-.641,0-1.008-.015-2.018.015-3.025a3.34,3.34,0,0,1,2.986-3.121,20.96,20.96,0,0,1,2.747,0,3.332,3.332,0,0,1,3,3.153c.03,1.029.014,2.059.012,3.088,0,.368-.2.546-.592.546q-1.9,0-3.8,0",
    transform: "translate(18.809 268.868)",
    fill: "#ef7b13"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44592",
    "data-name": "Path 44592",
    d: "M5.1,88.19a5.31,5.31,0,0,0-.219,1.881c.006.63,0,1.26,0,1.89v1.007c-.027,0-.1.008-.172.008H.631c-.454,0-.628-.17-.628-.615,0-.658-.009-1.316.01-1.974a2.389,2.389,0,0,1,2.246-2.273c.783-.024,1.568-.008,2.351,0a3.583,3.583,0,0,1,.486.074",
    transform: "translate(75.476 248.694)",
    fill: "#ef7b13"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44593",
    "data-name": "Path 44593",
    d: "M165.666,92.978c0-1.033,0-2.038,0-3.044a4.945,4.945,0,0,0-.219-1.734,2.989,2.989,0,0,1,.476-.082c.812-.008,1.624-.028,2.435,0a2.392,2.392,0,0,1,2.167,2.175c.033.727.017,1.456.011,2.184,0,.316-.208.495-.552.5-.616,0-1.232,0-1.848,0h-2.471",
    transform: "translate(-75.685 248.694)",
    fill: "#ef7b13"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44594",
    "data-name": "Path 44594",
    d: "M13.462,22.111A2.433,2.433,0,0,1,15.9,24.553a2.435,2.435,0,1,1-4.871-.021,2.42,2.42,0,0,1,2.432-2.421",
    transform: "translate(65.422 308.846)",
    fill: "#ef7b13"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44595",
    "data-name": "Path 44595",
    d: "M86.429,4.876a2.438,2.438,0,1,1,2.429-2.452,2.434,2.434,0,0,1-2.429,2.452",
    transform: "translate(-1.255 329)",
    fill: "#ef7b13"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44596",
    "data-name": "Path 44596",
    d: "M159.387,22.113a2.436,2.436,0,0,1,0,4.872,2.436,2.436,0,1,1,0-4.872",
    transform: "translate(-67.936 308.844)",
    fill: "#ef7b13"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployeesOrange);
export default __webpack_public_path__ + "static/media/employees_orange.12dcd700e7787eabcc31a92a6f4b3c35.svg";
export { ForwardRef as ReactComponent };